import { module } from 'angular';

import { default as indicatorFilterName, IndicatorFilter } from './indicator-filter.component.ajs';

export default module('hypervision.skill-view.custom.filter.indicator', []).component(indicatorFilterName, new IndicatorFilter()).name;
